import React from "react";
import CustomerList from "../../components/customers/customer-list.component";

const CustomerListPage = () => {
  return <CustomerList />;
};

export default CustomerListPage;
